import { render } from "./homeEditOffice.vue?vue&type=template&id=53ab318b&scoped=true"
import script from "./homeEditOffice.vue?vue&type=script&lang=js"
export * from "./homeEditOffice.vue?vue&type=script&lang=js"

import "./homeEditOffice.vue?vue&type=style&index=0&id=53ab318b&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ab318b"]])

export default __exports__